import { useCallback } from 'react';
import { useIsSafari } from '~/context/common/DeviceContext';
import getElementOffsetTop from './getElementOffsetTop';

/*
 * This is needed because Safari does not
 * smoothly scroll to anchor tag sections
 * */

const SmoothAnchor = ({
  children,
  'data-analytics-id': dataAnalyticsId,
  href,
  ...props
}) => {
  const isSafari = useIsSafari();
  const idWithoutHash = href.slice(1);

  const onClick = useCallback(
    e => {
      if (!isSafari) return;
      const section = document.getElementById(idWithoutHash);
      if (!section) return;
      e.preventDefault();
      const topOffset = getElementOffsetTop(section);

      window.scroll({
        top: topOffset,
        behavior: 'smooth'
      });
    },
    [idWithoutHash, isSafari]
  );

  return (
    <a
      data-analytics-id={dataAnalyticsId}
      href={href}
      onClick={onClick}
      {...props}
    >
      {children}
    </a>
  );
};

export default SmoothAnchor;
